import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ProgressState } from 'rxjs-uploader';
import { InvoiceFileUpload } from '../../../invoices/invoices.models';

@Component({
    selector: 'additional-uploads-row-item',
    template: `
        <div class="additional-uploads-row-item" [ngClass]="{ 'is-selected': isSelected }">
            <div class="left-half">
                <lsq-icon
                    *ngIf="isSuccess"
                    [color]="color.Green"
                    [type]="icons.CheckmarkSmall"
                    class="item-spacing"
                >
                </lsq-icon>
                <div class="file-name">
                    {{ fileUpload?.name
                    }}<span *ngIf="fileUpload.hasFailed" class="failed-message"
                        >&nbsp;(Upload Failed)</span
                    >
                </div>
            </div>
            <div class="right-half">
                <lsq-button
                    *ngIf="!isSelected && fileUpload.isUploadStatusComplete"
                    appearance="transparent"
                    class="item-spacing"
                    (buttonClick)="onView.emit()"
                    >View</lsq-button
                >
                <lsq-button
                    *ngIf="fileUpload.uploaded || fileUpload.hasFailed"
                    appearance="transparent"
                    (buttonClick)="onDelete.emit()"
                >
                    <lsq-icon
                        [type]="icons.Trash"
                        [color]="color.GrayDarker"
                        [hoverColor]="color.Black"
                        class="item-spacing"
                    ></lsq-icon>
                </lsq-button>
            </div>
            <div
                *ngIf="fileUpload.progress.state === uploadingState || fileUpload.hasFailed"
                class="row-item-progress-bar-container"
                [ngClass]="{ uploaded: fileUpload.uploaded }"
            >
                <lsq-progress-bar
                    [value]="fileUpload.progressPercentage"
                    [danger]="fileUpload.hasFailed"
                    [skinny]="true"
                >
                </lsq-progress-bar>
            </div>
        </div>
    `,
    styleUrls: ['additional-uploads-row-item.component.scss']
})
export class AdditionalUploadsRowItemComponent {
    @Input() public fileUpload: InvoiceFileUpload;
    @Input() public isSuccess = true;
    @Input() public isSelected = false;
    @Output() public onDelete = new EventEmitter();
    @Output() public onView = new EventEmitter();
    public icons = Icons;
    public color = Color;
    public uploadingState = ProgressState.InProgress;
}
